// "off": everyone gets the current flow. "internal": only staff, and testers
// who opened any page with ?onboarding=new first, get the new flow; nobody
// else is assigned. "live": the 50/50 test. "full": everyone gets the new flow.
export type TOnboardingRollout = "off" | "internal" | "live" | "full";
export const ONBOARDING_ROLLOUT = "full" as TOnboardingRollout;
